import './Admin-signup.css';
import React, { useState, useEffect, useCallback } from 'react';
import ThemeSwitch from '../../Components/themeSwitch/themeSwitch';
import LeftSidePanel from '../../Components/leftSidePanel/leftSidePanel';
import countriesData from '../../Data/CountryCodes.json';
import zxcvbn from 'zxcvbn';
import OTPInputWithTimer from '../../Components/OTPInput/otpInputField';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { debounce, method } from 'lodash';
import CustomerLeftPanel from '../../Components/CustomerLeftPanel/customer-left-panel';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import { CUSTOMER_TYPES } from '../../Constants/config';
import PhoneInput from '../../Components/CustomDropdown/input-phone';
import ContactUs from '../../Pages/Contact-Us/contact-us';
import { motion, AnimatePresence } from 'framer-motion';
import PricingPlanCards from '../../Components/pricing-plan/pricing-plan-cards';
import { Sparkles, Info, X, ShieldCheck } from 'lucide-react';
import WholesaleCalculator from '../Subscription/wholesale-layer';

const validator = require('validator');

const AdminSignup = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [open, setOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState('');
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setfirstName] = useState('');
  const [lastName, setlastName] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const [focus, setFocus] = useState(false);
  const [countries, setCountries] = useState([]);
  const [strength, setStrength] = useState(null);
  const [strengthText, setStrengthText] = useState('');
  const [color, setColor] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailVerfied, setEmailVerfied] = useState(false);
  const [qrscreen, setQrscreen] = useState(false);
  const [otp, setOtp] = useState('');
  const [userId, setUserId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const location = useLocation();
  const [focusedField, setFocusedField] = useState(null);
  const [mobileNumberSecond, setMobileNumberSecond] = useState('');
  const [selectedCodeSecond, setSelectedCodeSecond] = useState('');
  const [mobileFieldEnabled, setMobileFieldEnabled] = useState(true);
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [emailSecond, setEmailSecond] = useState('');
  const [emailfieldEnabled, setEmailfieldEnabled] = useState(true);
  const [showAuthQRCode, setShowAuthQRCode] = useState(false);
  const [showLoginQr, setShowLoginQr] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('terms');
  const [loading, setLoading] = useState(false);
  const [customerType, setCustomerType] = useState(null);
  const [plan, setPlan] = useState(1);
  const [preselectedPlan, setpreselectedPlan] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [subPlanData, setSubPlanData] = useState([]);
  const isMobile = window.innerWidth < 768;
  const [androidImage, setAndroidImage] = useState('');
  const [IOSImage, setIOSImage] = useState('');
  // TWO_FACTOR_TYPE from the API. mobile_app = download the app screen, email_otp = verify on web
  const [signupTwoFactorType, setSignupTwoFactorType] = useState('mobile_app');
  const navigate = useNavigate();
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const handleSelectCustomerType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setCustomerType(selectedOption.label);
  };
  const getQRImages = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/settings/app-qr-codes`);
      if (response.status == 200) {
        setAndroidImage(response.data.android);
        setIOSImage(response.data.ios);
        setTimeout(() => {}, 700);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
      }
      showToast(err.message, 'error');
    }
  };
  const handleSelectPlan = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setPlan(selectedOption.value);
  };

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleCodeChangeSecond = (e) => {
    setSelectedCodeSecond(e.target.value);
  };

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleScroll = () => {
    if (document.activeElement instanceof HTMLInputElement) {
      document.activeElement.blur(); // Remove focus
    }
  };
  const decode = (value, isMobile = false) => {
    if (!value) return '';

    const decoded = decodeURIComponent(value);

    // ✅ Only replace + for non-mobile fields
    return isMobile ? decoded : decoded.replace(/\+/g, ' ');
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const decode = (value) =>
      value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';

    const firstNameParam = decode(params.get('firstName'));
    const emailParam = decode(params.get('email'));
    const mobileParam = params.get('mobileNumber'); // no + replacement
    const countryCodeParam = params.get('countryCode'); // keep as is
    const planParam = params.get('plan');

    if (firstNameParam) setfirstName(firstNameParam);
    if (emailParam) setEmail(emailParam);
    console.log('planparam ' + planParam);
    if (planParam && subPlanData?.length) {
      setPlan(planParam);

      const selectedPlan = subPlanData.find(
        (item) => String(item.value) === planParam,
      );

      console.log('selectedPlan:', selectedPlan);

      if (selectedPlan) {
        setpreselectedPlan({
          value: selectedPlan.id,
          label: selectedPlan.label,
        });
      }
    }
    if (countryCodeParam) {
      setSelectedCode(decodeURIComponent(countryCodeParam)); // +92
    }

    if (mobileParam) {
      setMobileNumber(mobileParam);
    }
  }, [location.search, subPlanData]);
  useEffect(() => {
    if (subPlanData.length > 0 && preselectedPlan != null) {
      const selectedPlan = subPlanData?.find(
        (p) => p.value === preselectedPlan,
      );
      setSelectedPlan(selectedPlan);
    }
  }, [preselectedPlan, subPlanData]);
  useEffect(() => {
    if (selectedPlan != null) {
      setPlan(selectedPlan.id);
    }
  }, [selectedPlan]);
  const GetAPIcalls = async (url) => {
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getUserTypes = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/auth/user-types`);

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label:
              profile.name?.charAt(0).toUpperCase() + profile.name?.slice(1),
          });
        });
        setCustomerTypeData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setCustomerTypeData([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setCustomerTypeData([]);
    }
  };
  const getsubsciptionType = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/auth/subscription-types`);

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.label,
          });
        });
        setSubPlanData(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setSubPlanData([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setSubPlanData([]);
    }
  };
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (document.activeElement instanceof HTMLInputElement) {
  //       document.activeElement.blur(); // Remove focus
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  // registration session ran out, login will ask for whatever is still not verified
  const isExpiredSessionError = (err) =>
    (err?.message || '').toLowerCase().includes('expired session');

  const postSendEmailCode = async (userId, sessionId) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/send-mfa-code`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      method: 'email',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postChangeEmail = async (userId, email) => {
    const apiUrl = `${BASE_URL}/v1/auth/change-email`;
    const bodyData = {
      user_id: userId,
      new_email: email,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postChangeMobileNumber = async (userId, code, mobileNumber) => {
    const apiUrl = `${BASE_URL}/v1/auth/change-mobile-number`;
    const bodyData = {
      user_id: userId,
      new_mobile_number: mobileNumber,
      country_code: code,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postSendMobileCode = async () => {
    const apiUrl = `${BASE_URL}/api/v1/auth/send-mfa-code`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      method: 'sms',
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postLoginAPI = async () => {
    const apiUrl = `${BASE_URL}/api/v1/onboarding/register`;
    const bodyData = {
      first_name: firstName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: email,
      password: password,
      role: 'agency',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const postEmailCodeVerification = async () => {
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-mfa-code`;
    const bodyData = {
      user_id: userId,
      code: otp,
      session_id: sessionId,
      method: 'email',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  // Handle form submission
  const handleSubmitEmail = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await postEmailCodeVerification();
        if (response.status == 200) {
          toastMessage = {
            message: 'Email verified successfully.',
            type: 'success',
          };
          // email is done, now the mobile number gets its own OTP before we go to login.
          // clear the email code so it is not submited again on the mobile screen
          setOtp('');
          setEmailVerfied(true);
          try {
            const responseMobileCode = await postSendMobileCode();
            if (responseMobileCode.status == 200) {
              toastMessage = {
                message: 'Email verified. OTP sent to your mobile number.',
                type: 'success',
              };
            }
          } catch (mobileCodeError) {
            // user can still hit resend on the mobile screen
            toastMessage = { message: mobileCodeError.message, type: 'error' };
          }
        } else {
          setEmailVerfied(false);
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        if (isExpiredSessionError(err)) {
          toastMessage = {
            message:
              'Your sign up session expired. Please log in to finish verifying your account.',
            type: 'error',
          };
          navigate('/login');
          return;
        }
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId], // Dependencies
  );
  const postMobileCodeVerification = async () => {
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-mfa-code`;
    const bodyData = {
      user_id: userId,
      code: otp,
      session_id: sessionId,
      method: 'sms',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postMobileCodeVerification();

        if (response.status == 200) {
          toastMessage = {
            message: 'Mobile Number verified.',
            type: 'success',
          };
          navigate('/login');
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        if (isExpiredSessionError(err)) {
          toastMessage = {
            message:
              'Your sign up session expired. Please log in to finish verifying your account.',
            type: 'error',
          };
          navigate('/login');
          return;
        }
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId], // Dependencies
  );
  const handleSubmit = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await postLoginAPI();

        if (response.status == 201) {
          // register response wins over the value we fetched on page load
          const activeTwoFactorType =
            response.data.two_factor_type || signupTwoFactorType;
          setSignupTwoFactorType(activeTwoFactorType);
          if (activeTwoFactorType !== 'email_otp') {
            // mobile_app, same as before: show the download the app screen
            getQRImages();
            setQrscreen(true);
            return;
          }
          console.log('Login successful');
          setUserId(response.data.user_id);
          setSessionId(response.data.session_id);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseEmailCode = await postSendEmailCode(
            response.data.user_id,
            response.data.session_id,
          );
          if (responseEmailCode.status == 200) {
            setFormSubmitted(true);
            toastMessage = {
              message: 'OTP sent successfully!',
              type: 'success',
            };
          } else {
            setFormSubmitted(false);
            toastMessage = {
              message: responseEmailCode.message,
              type: 'error',
            };
            return;
          }
        } else {
          setFormSubmitted(false);
          showToast(response.message, 'error');
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      email,
      password,
      firstName,
      selectedCode,
      mobileNumber,
      customerType,
      plan,
      signupTwoFactorType,
    ], // Dependencies
  );
  const handleSubmitEmailCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseEmailCode = await postSendEmailCode(userId, sessionId);
        if (responseEmailCode.status == 200) {
          setFormSubmitted(true);
          toastMessage = {
            message: 'OTP sent successfully!',
            type: 'success',
          };
        } else {
          setFormSubmitted(false);
          toastMessage = { message: responseEmailCode.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, sessionId], // Dependencies
  );
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Check password strength
    const result = zxcvbn(value);
    const score = result.score;

    // Set strength level
    setStrength(score);

    // Set condition text and color
    switch (score) {
      case 0:
        setStrengthText('Very Weak');
        setColor('text-red-500');
        break;
      case 1:
        setStrengthText('Weak');
        setColor('text-orange-500');
        break;
      case 2:
        setStrengthText('Moderate');
        setColor('text-yellow-500');
        break;
      case 3:
        setStrengthText('Strong');
        setColor('text-green-500');
        break;
      case 4:
        setStrengthText('Very Strong');
        setColor('text-blue-500');
        break;
      default:
        setStrengthText('');
        setColor('');
    }
  };
  const calculateStrength = (password) => {
    let score = 0;

    // Conditions
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    return score;
  };

  const strengthScore = calculateStrength(password);
  const handleSubmitMobileCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const responseEmailCode = await postSendMobileCode();
        if (responseEmailCode.status == 200) {
          setEmailVerfied(true);
          setFormSubmitted(true);
          toastMessage = { message: 'OTP sent successfully!', type: 'success' };
        } else {
          setEmailVerfied(false);
          toastMessage = {
            message: responseEmailCode.message,
            type: 'error',
          };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, otp, sessionId], // Dependencies
  );
  useEffect(() => {
    getUserTypes();
    getsubsciptionType();
  }, []);
  // Ask the API which second step is on, register response also sends it back
  useEffect(() => {
    const loadTwoFactorType = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/v1/auth/two-factor-type`);
        const body = await response.json();
        if (response.ok && body?.data?.two_factor_type) {
          setSignupTwoFactorType(body.data.two_factor_type);
        }
      } catch (err) {
        // older API without this endpoint, keep the mobile app flow
        console.log('Two factor type not available, using mobile app flow');
      }
    };
    loadTwoFactorType();
  }, [BASE_URL]);
  return (
    <div className="flex flex-col lg:flex-row min-h-[100dvh]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <CustomerLeftPanel />
      {/* {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )} */}
      {/* Right side */}
      <div className="w-full lg:w-2/5 flex flex-col h-[100dvh] bg-[#FFFFFF] overflow-y-auto ">
        <div className="dark:bg-[#101010]  w-full  bg-[#FAFAFA] flex justify-end py-[10px] px-[15px]">
          <button
            onClick={() => setIsSupportOpen(true)}
            className={`flex items-center bg-black  h-11 gap-2 px-3 py-2 text-xs rounded-xl transition-all duration-200 text-white shadow hover:scale-105`}
            style={{ background: '' }}
          >
            {/* Icon */}
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 13a3 3 0 01-3 3h-1v-4h1a3 3 0 013 3zM6 13a3 3 0 003 3h1v-4H9a3 3 0 00-3 3z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3a9 9 0 00-9 9v3a3 3 0 003 3h1v-6H6a6 6 0 1112 0h-1v6h1a3 3 0 003-3v-3a9 9 0 00-9-9z"
              />
            </svg>

            {/* Text */}
            <span className="hidden sm:inline">Need Help?</span>
          </button>
        </div>
        {isSupportOpen && (
          <div className="fixed inset-0 z-[20] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            {/* Modal */}
            <ContactUs
              onClose={() => setIsSupportOpen(false)}
              isLogin={false}
            />
          </div>
        )}
        {formSubmitted ? (
          <div>
            {emailVerfied && !showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please Verify your Mobile
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast('Please Enter 6 digit OTP', 'error');
                      return;
                    }
                    setLoading(true);
                    handleSubmitMobile(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your mobile number for the verification code we
                    just sent you and enter the code in the box below
                  </p>
                  <div className="mb-6">
                    <label
                      htmlFor="mobileNumber"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Mobile Number<span className="text-red-500">*</span>
                    </label>
                    {showUpdateButton && (
                      <div className="flex  items-center">
                        <select
                          value={selectedCodeSecond}
                          onChange={handleCodeChangeSecond}
                          disabled={mobileFieldEnabled}
                          className={`border text-code disabled-text font-medium 
                             h-11
                           p-2 rounded-tl-lg appearance-none ounded-tr-none rounded-br-none rounded-bl-lg border focus:border-black border-r-0   border  py-2 px-3 leading-tight focus:outline-none `}
                          placeholder="AU+61"
                        >
                          {countries.map((country) => (
                            <option key={country.code} value={country.dialCode}>
                              {country.code} {country.dialCode}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          id="mobileNumber"
                          value={mobileNumberSecond}
                          disabled={mobileFieldEnabled}
                          onChange={(e) =>
                            setMobileNumberSecond(e.target.value)
                          }
                          placeholder="Mobile Number"
                          className={`border text-black disabled-text text-base font-medium h-11
                           p-2 rounded-tl-none rounded-tr-lg rounded-br-lg rounded-bl-none border focus:border-black rounded focus:outline-none w-full border-l-0 appearance-none`}
                        />
                      </div>
                    )}
                    {!showUpdateButton && (
                      <div className="flex  items-center">
                        <select
                          value={selectedCode}
                          onChange={handleCodeChange}
                          disabled={mobileFieldEnabled}
                          className={`border appearance-none text-code disabled-text font-medium h-11
                           p-2 rounded-tl-lg rounded-tr-none rounded-br-none rounded-bl-lg border focus:border-black border-r-0   border  py-2 px-3 leading-tight focus:outline-none `}
                          placeholder="AU+61"
                        >
                          {countries.map((country) => (
                            <option key={country.code} value={country.dialCode}>
                              {country.code} {country.dialCode}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          id="mobileNumber"
                          value={mobileNumber}
                          disabled={mobileFieldEnabled}
                          onChange={(e) => setMobileNumber(e.target.value)}
                          placeholder="Mobile Number"
                          className={`border text-black disabled-text text-base font-medium h-11
                           p-2 rounded-tl-none rounded-tr-lg rounded-br-lg rounded-bl-none border focus:border-black rounded focus:outline-none w-full border-l-0 appearance-none`}
                        />
                      </div>
                    )}
                  </div>
                  {/* uncomment if it is rqeuired in future */}
                  {/* <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            !validator.isMobilePhone(
                              selectedCodeSecond + mobileNumberSecond,
                              "any"
                            )
                          ) {
                            console.log("country code " + selectedCodeSecond);
                            console.log(
                              "mobile number is " + mobileNumberSecond
                            );
                            console.log(
                              validator.isMobilePhone(
                                selectedCodeSecond + mobileNumberSecond,
                                "any"
                              )
                            );
                            showToast(
                              "Please enter valid mobile number",
                              "error"
                            );
                            return;
                          }
                          updateMobileNumber(e);
                        }}
                        href="#"
                        className={`text-sm font-medium  after-login hover:underline ${
                          showUpdateButton ? "Show" : "Hide"
                        }`}
                      >
                        Update
                      </a>
                    </div>
                    <a
                      onClick={enableMobile}
                      href="#"
                      className=" text-sm font-medium  after-login hover:underline"
                    >
                      change Mobile Number?
                    </a>
                  </div> */}
                  <div className="mb-4">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={userId}
                      postCode={handleSubmitMobileCode}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            {!emailVerfied && !showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Please Verify your email
                </h2>

                <form
                  className="w-full max-w-sm"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (otp.length < 6) {
                      showToast('Please Enter 6 digit OTP', 'error');
                      return;
                    }
                    setLoading(true);
                    handleSubmitEmail(e);
                  }}
                >
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please check your email for the verification code we just
                    sent you and enter the code in the box below
                  </p>
                  <div className="mb-6">
                    <label
                      htmlFor="firstName"
                      className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                    >
                      Code sent to:
                    </label>
                    {showUpdateButton && (
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={emailSecond}
                        required={true}
                        disabled={emailfieldEnabled}
                        onChange={(e) => setEmailSecond(e.target.value)}
                        className="rounded-lg h-11 border disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    )}
                    {!showUpdateButton && (
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={email}
                        required={true}
                        disabled={emailfieldEnabled}
                        onChange={(e) => setEmailSecond(e.target.value)}
                        className="rounded-lg h-11 border disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    )}
                  </div>
                  {/* Uncomment if required */}
                  {/* <div className="flex items-center pt justify-between mb-6">
                    <div className="flex items-center">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(emailSecond)) {
                            showToast("Enter the valid email", "error");
                            return;
                          }
                          updateEmail(e);
                        }}
                        href="#"
                        className={`text-sm font-medium  after-login hover:underline ${
                          showUpdateButton ? "Show" : "Hide"
                        }`}
                      >
                        {" "}
                        Update{" "}
                      </a>
                    </div>
                    <button onClick={enableEmail}>
                      <a className=" text-sm font-medium  after-login hover:underline">
                        change Email?
                      </a>
                    </button>
                  </div> */}
                  <div className="mb-4">
                    <OTPInputWithTimer
                      onOtpChange={(value) => setOtp(value)}
                      onLoadingChange={(value) => setLoading(value)}
                      initialTime={300}
                      userId={userId}
                      postCode={handleSubmitEmailCode}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            {emailVerfied && showAuthQRCode && !showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Download Ratified Mobile Application.
                </h2>

                <form className="w-full max-w-sm" onSubmit={handleSubmitMobile}>
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please scan the below QR code to Download the Ratified
                    Authenticator App & Register for easy access.
                  </p>
                  <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                    {/* iOS QR Code */}
                    <div className="flex flex-col items-center">
                      <div className="flex items-center  max-w-fit  gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-[#375AE7]">
                        <img
                          src="/apple-logo.svg"
                          alt="iOS QR Code"
                          className="w-4 h-4"
                        />
                        <div className="flex flex-col leading-tight">
                          <p className="text-[10px] text-black whitespace-nowrap">
                            Download on the
                          </p>
                          <p className="text-md font-semibold text-black whitespace-nowrap">
                            App Store
                          </p>
                        </div>
                      </div>
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>

                    {/* QR Code Label */}
                    <p className="text-sm text-labelColour font-medium">
                      Scan the QR Code
                    </p>

                    {/* Android QR Code */}
                    <div className="flex flex-col items-center">
                      <div className="flex items-center  max-w-fit  gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-[#375AE7]">
                        <img
                          src="/playstore-logo.svg"
                          alt="iOS QR Code"
                          className="w-4 h-4"
                        />
                        <div className="flex flex-col leading-tight">
                          <p className="text-[10px] text-black whitespace-nowrap">
                            Get It On
                          </p>
                          <p className="text-md font-semibold text-black whitespace-nowrap">
                            Google Play
                          </p>
                        </div>
                      </div>
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Continue
                  </button>
                </form>
              </div>
            )}
            {emailVerfied && showAuthQRCode && showLoginQr && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Set up your account on the Capock Mobile Application.
                </h2>

                <form className="w-full max-w-sm" onSubmit={handleSubmitMobile}>
                  <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                    Please scan the QR code below using the Ratified mobile
                    application for easily log in.
                  </p>
                  <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                    {/* iOS QR Code */}
                    <div className="flex flex-col items-center">
                      <a
                        href="https://apps.apple.com"
                        className=" mt-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/bar.png"
                          alt="App Store"
                          className="w-36 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        ) : (
          <>
            {!qrscreen && (
              <div className="w-full mx-auto max-w-sm mt-10">
                <h2 className="text-2xl dark:text-white font-medium mb-6 text-center">
                  Open Account
                </h2>
                <div className="w-full h-full overflow-y-auto">
                  <form
                    className="w-full max-w-sm"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (!validateEmail(email)) {
                        showToast('Enter the valid email', 'error');
                        return;
                      }
                      const normalizeMobile = (number) => {
                        if (!number) return '';
                        return number.replace(/^0+/, '');
                      };

                      const formattedMobile = normalizeMobile(mobileNumber);
                      if (
                        !validator.isMobilePhone(
                          selectedCode + formattedMobile,
                          'any',
                        )
                      ) {
                        console.log('country code ' + selectedCode);
                        console.log('mobile number is ' + mobileNumber);
                        console.log(
                          validator.isMobilePhone(
                            selectedCode + mobileNumber,
                            'any',
                          ),
                        );
                        showToast('Please enter valid mobile number', 'error');
                        return;
                      }
                      if (strengthScore < 4) {
                        showToast('Please Enter valid password', 'error');
                        return;
                      }
                      if (password !== confirmPassword) {
                        showToast(
                          'Confirm password should be same as password',
                          'error',
                        );
                        return;
                      }
                      // if (!customerType) {
                      //   showToast('Please select customer type', 'error');
                      //   return;
                      // }
                      setLoading(true);
                      handleSubmit(e);
                    }}
                  >
                    <div className="mb-4">
                      <label
                        htmlFor="firstName"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Full Name<span className="text-red-500">*</span>
                      </label>
                      <input
                        id="firstName"
                        name="firstName"
                        type="text"
                        value={firstName}
                        placeholder="Your Full Name"
                        className="rounded-lg h-11 border border-gray-300 text-black text-base font-medium w-full px-3 py-2
  focus:outline-none focus:border-black focus:border-2
  dark:bg-[#101010] dark:text-white dark:border-[#4F4F4F]"
                        onChange={(e) => setfirstName(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        htmlFor="firstName"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Mobile Number<span className="text-red-500">*</span>
                      </label>
                      <PhoneInput
                        countries={countries}
                        onChange={(val) => {
                          setSelectedCode(val.code);
                          setMobileNumber(val.number);
                        }}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Email<span className="text-red-500">*</span>
                      </label>
                      <input
                        id="email"
                        name="email"
                        type="text"
                        value={email}
                        autoComplete="off"
                        placeholder="Your Email"
                        className={`rounded-lg h-11 border border-gray-300 text-black text-base font-medium w-full px-3 py-2
  focus:outline-none focus:border-black focus:border-2
  dark:bg-[#101010] dark:text-white dark:border-[#4F4F4F] ${
    email != '' && !validateEmail(email)
      ? 'border-[#FF5050] border-2'
      : 'border'
  }`}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <div className="min-h-[20px]">
                        {email != '' && !validateEmail(email) && (
                          <label
                            htmlFor="confirmpassword"
                            className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                          >
                            <img
                              src="/danger.svg"
                              alt="alert Icon"
                              className="h-4 w-4 mr-2"
                            />
                            Please enter a valid email address.
                          </label>
                        )}
                      </div>
                    </div>
                    {/* Password */}
                    <div className="mb-4">
                      <div className="relative mt-1">
                        {/* Password Input Field */}
                        <label
                          htmlFor="password"
                          className="block color-test dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Password
                        </label>
                        <input
                          type={showPassword ? 'text' : 'password'}
                          value={password}
                          id="password"
                          onChange={handlePasswordChange}
                          className="rounded-lg h-11 border border-gray-300 text-black text-base font-medium w-full px-3 py-2
  focus:outline-none focus:border-black focus:border-2
  dark:bg-[#101010] dark:text-white dark:border-[#4F4F4F]"
                          placeholder="Type password"
                        />
                        <button
                          type="button"
                          onClick={togglePassword}
                          className="absolute right-3 set-top"
                        >
                          {' '}
                          {showPassword ? (
                            <img src="/eye.svg" alt="Logo" className="h-auto" />
                          ) : (
                            <img
                              src="/eye-slash.svg"
                              alt="Logo"
                              className="h-auto"
                            />
                          )}
                        </button>

                        <div className="display-none flex gap-1  absolute top-0 right-0 mt-4">
                          <div
                            className={
                              strengthScore > 0 && strengthScore < 2
                                ? 'bg-red-400 px-4 h-1 rounded-md'
                                : strengthScore >= 2 && strengthScore < 4
                                  ? 'bg-yellow-400 px-4 h-1 rounded-md'
                                  : strengthScore === 4
                                    ? 'bg-green-400 px-4 h-1 rounded-md'
                                    : 'bg-gray-400 px-4 h-1 rounded-md'
                            }
                          ></div>
                          <div
                            className={
                              strengthScore >= 2 && strengthScore < 4
                                ? 'bg-yellow-400 px-4 h-1 rounded-md'
                                : strengthScore === 4
                                  ? 'bg-green-400 px-4 h-1 rounded-md'
                                  : 'bg-gray-400 px-4 h-1 rounded-md'
                            }
                          ></div>
                          <div
                            className={
                              strengthScore >= 3 && strengthScore < 4
                                ? 'bg-yellow-400 px-4 h-1 rounded-md'
                                : strengthScore === 4
                                  ? 'bg-green-400 px-4 h-1 rounded-md'
                                  : 'bg-gray-400 px-4 h-1 rounded-md'
                            }
                          ></div>
                          <div
                            className={
                              strengthScore === 4
                                ? 'bg-green-400 px-4 h-1 rounded-md'
                                : 'bg-gray-400 px-4 h-1 rounded-md'
                            }
                          ></div>
                        </div>
                      </div>
                      {/* Password Validation Conditions */}
                      <div className="mt-4 text-md font-medium">
                        <ul>
                          <li
                            className={
                              password.length >= 8
                                ? 'text-black'
                                : 'text-[#BEBEBE]'
                            }
                          >
                            {password.length >= 8 ? (
                              <img
                                src="/tick-circle.svg"
                                alt="check"
                                className="w-5 h-5 inline mr-2 text-green-500"
                              />
                            ) : (
                              <img
                                src="/tick-circle-empty.svg"
                                alt="cross"
                                className="w-5 h-5 inline mr-2 text-red-500"
                              />
                            )}
                            At least 8 characters
                          </li>
                          <li
                            className={
                              /(?=.*[0-9])/.test(password)
                                ? 'text-black'
                                : 'text-[#BEBEBE]'
                            }
                          >
                            {/(?=.*[0-9])/.test(password) ? (
                              <img
                                src="/tick-circle.svg"
                                alt="check"
                                className="w-5 h-5 inline mr-2 text-green-500"
                              />
                            ) : (
                              <img
                                src="/tick-circle-empty.svg"
                                alt="cross"
                                className="w-5 h-5 inline mr-2 text-red-500"
                              />
                            )}
                            At least 1 number
                          </li>
                          <li
                            className={
                              /(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                password,
                              )
                                ? 'text-black'
                                : 'text-[#BEBEBE]'
                            }
                          >
                            {/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                              password,
                            ) ? (
                              <img
                                src="/tick-circle.svg"
                                alt="check"
                                className="w-5 h-5 inline mr-2 text-green-500"
                              />
                            ) : (
                              <img
                                src="/tick-circle-empty.svg"
                                alt="cross"
                                className="w-5 h-5 inline mr-2 text-red-500"
                              />
                            )}
                            At least 1 special character
                          </li>
                          <li
                            className={
                              /(?=.*[a-z])/.test(password) &&
                              /(?=.*[A-Z])/.test(password)
                                ? 'text-black'
                                : 'text-[#BEBEBE]'
                            }
                          >
                            {/(?=.*[a-z])/.test(password) &&
                            /(?=.*[A-Z])/.test(password) ? (
                              <img
                                src="/tick-circle.svg"
                                alt="check"
                                className="w-5 h-5 inline mr-2 text-green-500"
                              />
                            ) : (
                              <img
                                src="/tick-circle-empty.svg"
                                alt="cross"
                                className="w-5 h-5 inline mr-2 text-red-500"
                              />
                            )}
                            Both upper and lower case characters
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="mb-4 relative">
                      <label
                        htmlFor="password"
                        className="block color-test dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Confirm Password
                      </label>
                      <input
                        type={showconfirmPassword ? 'text' : 'password'}
                        value={confirmPassword}
                        id="password"
                        onChange={(e) => setconfirmPassword(e.target.value)}
                        className={`rounded-lg h-11 border border-gray-300 text-black text-base font-medium w-full px-3 py-2
  focus:outline-none focus:border-black focus:border-2
  dark:bg-[#101010] dark:text-white dark:border-[#4F4F4F] ${
    confirmPassword != '' && password != confirmPassword
      ? 'border-[#FF5050] border-2'
      : 'border'
  }`}
                        placeholder="Re-Type password"
                      />

                      <button
                        type="button"
                        onClick={toggleConfirmPassword}
                        className="absolute right-3 set-top"
                      >
                        {' '}
                        {showconfirmPassword ? (
                          <img src="/eye.svg" alt="Logo" className="h-auto" />
                        ) : (
                          <img
                            src="/eye-slash.svg"
                            alt="Logo"
                            className="h-auto"
                          />
                        )}
                      </button>
                      {confirmPassword != '' && password != confirmPassword && (
                        <label
                          htmlFor="confirmpassword"
                          className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                        >
                          <img
                            src="/danger.svg"
                            alt="alert Icon"
                            className="h-4 w-4 mr-2"
                          />
                          Please make sure your passwords match.
                        </label>
                      )}
                    </div>

                    {/* <div className="mb-4">
                      <Dropdown
                        label={
                          <>
                            Subscription Plan
                            <span className="text-red-500">*</span>
                          </>
                        }
                        options={subPlanData}
                        onSelect={handleSelectPlan}
                        preselectedValue={preselectedPlan}
                      />
                    </div> */}
                    {/* <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        Subscription Plan<span className="text-red-500">*</span>
                      </label>
                      <div className="mt-3 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                        <div className="relative flex-1">
                          <input
                            readOnly
                            value={selectedPlan?.name || 'No plan selected'}
                            className="
        w-full
        px-4
        py-3
        rounded-xl
        border
        border-slate-200
        bg-gradient-to-r
        from-slate-50
        to-white
        text-slate-700
        text-sm
        font-medium
        outline-none
        shadow-sm
      "
                          />

                          {selectedPlan && (
                            <span
                              className="
          absolute
          right-3
          top-1/2
          -translate-y-1/2
          text-xs
          px-2
          py-1
          rounded-full
          bg-emerald-50
          text-emerald-600
          font-medium
        "
                            >
                              Active
                            </span>
                          )}
                        </div>

                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="
      group
      inline-flex
      items-center
      justify-center
      gap-1
      px-4
      py-2
      rounded-full
      bg-[#375AE7]
      text-white
      text-xs
      font-semibold
      shadow-sm
      hover:shadow-md
      hover:bg-[#2F4FD0]
      transition-all
      active:scale-95
      whitespace-nowrap
    "
                        >
                          {selectedPlan ? (
                            <>
                              <span>Update</span>
                              <span className="hidden md:inline">Plan</span>
                            </>
                          ) : (
                            <>
                              <span>Select</span>
                              <span className="hidden sm:inline">Plan</span>
                            </>
                          )}
                        </button>
                      </div>

                      <p className="text-xs text-slate-500 mt-2">
                        You can upgrade or modify your subscription plan at any
                        time.
                      </p>
                    </div> */}
                    {/* <div className="mb-5">
                      <label className="block text-sm font-medium text-slate-700">
                        Subscription Plan
                        <span className="ml-1 text-red-500">*</span>
                      </label>

                      {!selectedPlan ? (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpen(true);
                          }}
                          className="
        mt-3
        group
        flex w-full
        items-center justify-between
        rounded-2xl
        border border-dashed border-slate-300
        bg-white
        px-4 py-4
        text-left
        transition-all duration-200
        hover:border-[#375AE7]
        hover:bg-blue-50/40
        hover:shadow-sm
      "
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className="
            flex h-10 w-10
            items-center justify-center
            rounded-xl
            bg-blue-50
            text-[#375AE7]
            transition
            group-hover:bg-[#375AE7]
            group-hover:text-white
          "
                            >
                              <span className="material-symbols-outlined text-[20px]">
                                add
                              </span>
                            </div>

                            <div>
                              <p className="text-sm font-semibold text-slate-800">
                                Add Subscription Plan
                              </p>

                              <p className="mt-0.5 text-xs text-slate-500">
                                Select a plan for this account
                              </p>
                            </div>
                          </div>

                          <span className="material-symbols-outlined text-[20px] text-slate-400 transition group-hover:translate-x-0.5 group-hover:text-[#375AE7]">
                            chevron_right
                          </span>
                        </button>
                      ) : (
                        <div
                          className="
        mt-3
        flex items-center justify-between
        rounded-2xl
        border border-emerald-200
        bg-gradient-to-r from-emerald-50/80 to-white
        px-4 py-4
      "
                        >
                          <div className="flex min-w-0 items-center gap-3">
                            <div
                              className="
            flex h-10 w-10 shrink-0
            items-center justify-center
            rounded-xl
            bg-emerald-100
            text-emerald-600
          "
                            >
                              <span className="material-symbols-outlined text-[20px]">
                                verified
                              </span>
                            </div>

                            <div className="min-w-0">
                              <p className="text-[10px] font-semibold uppercase tracking-wider text-emerald-600">
                                Your selected plan
                              </p>

                              <p className="mt-0.5 truncate text-sm font-semibold text-slate-900">
                                {selectedPlan.name}
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(true);
                            }}
                            className="
          ml-3
          shrink-0
          rounded-lg
          border border-slate-200
          bg-white
          px-3 py-2
          text-xs font-semibold
          text-slate-600
          shadow-sm
          transition
          hover:border-[#375AE7]
          hover:text-[#375AE7]
        "
                          >
                            Change
                          </button>
                        </div>
                      )}

                      <p className="mt-2 text-xs text-slate-500">
                        You can upgrade or modify your subscription plan at any
                        time.
                      </p>
                    </div> */}
                    <button
                      type="submit"
                      className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                    >
                      Get started
                    </button>
                  </form>
                  <div className="max-w-sm w-full mt-4 text-center">
                    <img src="/line.svg" alt="Logo" className="h-auto" />
                    <p className="color-test dark:text-[#CCCCCC] text-base pt-2">
                      Already have an Account?{' '}
                      <a
                        href="#"
                        onClick={() => navigate('/login')}
                        className="font-medium text-decoration text-black hover:underline"
                      >
                        Login Here
                      </a>{' '}
                    </p>
                    <p className="color-test dark:text-[#CCCCCC] text-base pt-2">
                      &copy; Ratified
                    </p>
                  </div>
                </div>
              </div>
            )}
            {qrscreen && (
              <AnimatePresence>
                <motion.div
                  key="Ratified-popup"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.4 }}
                  className="flex flex-col mt-10 justify-center items-center p-10 justify"
                >
                  <form className="w-full max-w-md">
                    {/* HEADER */}
                    <div className="text-center mb-8">
                      <span className="material-symbols-outlined text-3xl text-[#375AE7]">
                        smartphone
                      </span>

                      <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-2">
                        Get Started with Ratified App
                      </h2>

                      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        Follow the steps below to install and access your
                        account
                      </p>
                    </div>

                    {/* MAIN CONTENT */}
                    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 space-y-6">
                      {/* STEP 1 */}
                      <div className="flex gap-4">
                        {/* STEP INDICATOR */}
                        <div className="flex flex-col items-center">
                          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#375AE7] text-white text-sm font-semibold">
                            1
                          </div>
                          <div className="w-px h-full bg-gray-200 dark:bg-gray-700 mt-2"></div>
                        </div>

                        {/* CONTENT */}
                        <div className="w-full">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="material-symbols-outlined text-[#375AE7]">
                              download
                            </span>
                            <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                              Download Mobile Application
                            </h3>
                          </div>

                          {/* <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
          Install the Ratified mobile application using App Store or Google Play, or scan the QR code below.
        </p> */}
                          {isMobile ? (
                            <p className="text-sm mb-[32px] text-gray-600 dark:text-white mb-6">
                              Please press the below button to Download the
                              Ratified Authenticator App & Register for easy
                              access.
                            </p>
                          ) : (
                            <p className="text-sm mb-[32px] text-gray-600 dark:text-white mb-6">
                              Please scan the below QR code to Download the
                              Ratified Authenticator App & Register for easy
                              access.
                            </p>
                          )}

                          {/* STORE / QR */}
                          {!isMobile && (
                            <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                              {/* iOS */}
                              <div className="flex flex-col items-center">
                                <div className="flex items-center gap-2 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-1 bg-white dark:bg-gray-800">
                                  <img
                                    src="/apple-logo.svg"
                                    className="w-4 h-4"
                                  />
                                  <div className="leading-tight">
                                    <p className="text-[10px] text-gray-500">
                                      Download on the
                                    </p>
                                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                                      App Store
                                    </p>
                                  </div>
                                </div>

                                <a
                                  href={IOSImage}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={IOSImage}
                                    alt="iOS QR"
                                    className="w-32 mt-3 rounded-md shadow-sm"
                                  />
                                </a>
                              </div>

                              <span className="text-xs text-gray-400 hidden md:block">
                                OR
                              </span>

                              {/* Android */}
                              <div className="flex flex-col items-center">
                                <div className="flex items-center gap-2 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-1 bg-white dark:bg-gray-800">
                                  <img
                                    src="/playstore-logo.svg"
                                    className="w-4 h-4"
                                  />
                                  <div className="leading-tight">
                                    <p className="text-[10px] text-gray-500">
                                      Get it on
                                    </p>
                                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                                      Google Play
                                    </p>
                                  </div>
                                </div>

                                <a
                                  href={androidImage}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={androidImage}
                                    alt="Android QR"
                                    className="w-32 mt-3 rounded-md shadow-sm"
                                  />
                                </a>
                              </div>
                            </div>
                          )}

                          {isMobile && (
                            <div className="flex flex-col gap-4 w-full max-w-sm">
                              {/* iOS Button */}
                              <a
                                href="https://apps.apple.com/au/app/ratified/id6758427905"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center gap-3 border rounded-xl py-3 px-4 bg-black text-white shadow-md hover:opacity-90 transition"
                              >
                                <span className="material-symbols-outlined text-xl text-white">
                                  phone_iphone
                                </span>

                                <div className="text-left leading-tight">
                                  <p className="text-[10px] opacity-80">
                                    Download on the
                                  </p>
                                  <p className="text-sm font-semibold">
                                    App Store
                                  </p>
                                </div>
                              </a>

                              {/* Android Button */}
                              <a
                                href="https://play.google.com/store/apps/details?id=com.ratified&pcampaignid=web_share"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center gap-3 border rounded-xl py-3 px-4 bg-[#1a73e8] text-white shadow-md hover:opacity-90 transition"
                              >
                                <span className="material-symbols-outlined text-xl text-white">
                                  android
                                </span>

                                <div className="text-left leading-tight">
                                  <p className="text-[10px] opacity-80">
                                    Get it on
                                  </p>
                                  <p className="text-sm font-semibold">
                                    Google Play
                                  </p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* STEP 2 */}
                      <div className="flex gap-4 pt-5 border-t border-gray-200 dark:border-gray-700">
                        {/* STEP INDICATOR */}
                        <div className="w-12 h-6 flex items-center justify-center rounded-full bg-[#22c55e] text-white text-sm font-semibold">
                          2
                        </div>

                        {/* CONTENT */}
                        <div>
                          <div className="flex items-center gap-2 mb-2">
                            <span className="material-symbols-outlined text-green-600">
                              lock
                            </span>
                            <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                              Login to Mobile App
                            </h3>
                          </div>

                          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                            Use the same{' '}
                            <span className="font-semibold text-green-600">
                              email address and password
                            </span>{' '}
                            used on the web platform to securely access the
                            mobile application.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* CTA */}
                    {/* <button
    type="submit"
    className="w-full mt-6 bg-[#375AE7] hover:bg-[#2f4fd1] text-white font-medium py-3 rounded-full flex items-center justify-center gap-2 transition"
  >
    <img src="/arrow-left-password.svg" className="w-4 h-4" />
    Back to Login
  </button> */}
                    <button
                      onClick={() => {
                        navigate('/login');
                      }}
                      className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                    >
                      <img
                        src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                        alt="Icon"
                        className="w-4 h-4" // Adjust size as needed
                      />
                      Back To Log in
                    </button>
                  </form>
                </motion.div>
              </AnimatePresence>
            )}
          </>
        )}
      </div>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* BACKDROP */}
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          />

          {/* MODAL */}
          <div
            className="
        relative
        flex
        h-[90vh]
        w-full
        max-w-4xl
        flex-col
        overflow-hidden
        rounded-2xl
        border
        border-white
        bg-white
        shadow-[0_24px_70px_rgba(15,23,42,0.18)]
      "
          >
            {/* CLOSE BUTTON */}
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close modal"
              className="
          absolute
          right-4
          top-4
          z-50
          flex
          h-9
          w-9
          items-center
          justify-center
          rounded-xl
          border
          border-slate-200
          bg-white/95
          text-slate-500
          shadow-sm
          backdrop-blur
          transition-all
          duration-200
          hover:border-slate-300
          hover:bg-slate-50
          hover:text-slate-800
          hover:shadow-md
          active:scale-95
        "
            >
              <span className="material-symbols-outlined text-[19px]">
                close
              </span>
            </button>

            {/* SCROLLABLE CONTENT */}
            <div className="min-h-0 flex-1 overflow-y-auto">
              <WholesaleCalculator />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSignup;
